import { useMutation } from '@apollo/client';

import ShortFormContentTrackVideoProgress from 'bundles/clips/components/short-form-content/ShortFormContentTrackVideoProgress.graphql';

import type {
  ShortFormContentTrackVideoProgressMutation,
  ShortFormContentTrackVideoProgressMutationVariables,
} from '../components/short-form-content/__generated__/ShortFormContentTrackVideoProgress';

function useTrackVideoProgressMutation() {
  return useMutation<ShortFormContentTrackVideoProgressMutation, ShortFormContentTrackVideoProgressMutationVariables>(
    ShortFormContentTrackVideoProgress,
    {
      context: { clientName: 'gatewayGql' },
    }
  );
}

export default useTrackVideoProgressMutation;
